import { render, staticRenderFns } from "./ManageStockSummary.vue?vue&type=template&id=27407578&scoped=true&"
import script from "./ManageStockSummary.vue?vue&type=script&lang=js&"
export * from "./ManageStockSummary.vue?vue&type=script&lang=js&"
import style0 from "./ManageStockSummary.vue?vue&type=style&index=0&id=27407578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27407578",
  null
  
)

export default component.exports